export default "/images/earn_pay.png?c1c9c7df62b23c7126e0dcdd44619d6c";